<section class="competency-list-item">
    <section class="title-section">
        <h3>
            <a ng-click="onItemClick($event)" ng-bind-html="item.title|cHighlight:highlight"></a>
        </h3>
    </section>
    <section class="menu-section">
        <!--<a class="details button" ng-click="onItemDetails($event)" ng-attr-title="{{ 'workflowList.details'|translate }}"><i class="fa fa-info"></i></a>-->
    </section>
    <p ng-bind-html="(item.description)|cHighlight:highlight" class="description">
    </p>
    <div class="property-container">
        <ul class="workflow-property-list">
            <li ng-if="item.user">{{'competency.user'|translate}}: {{ item.user }} ({{item.userName}})</li>
            <li ng-if="item.validUntil">{{'competency.validUntil'|translate}}: {{ item.validUntil | cDate }}</li>
            <li ng-if="item.approvedBy">{{'competency.approvedBy'|translate}}: {{ item.approvedBy }} ({{item.approveByUserName}})</li>
            <li ng-if="item.approvedWhen">{{'competency.approvedWhen'|translate}}: {{ item.approvedWhen | cDate }}</li>
            <li ng-if="item.businessArea">{{'competency.businessArea'|translate}}: {{ item.businessArea }}</li>
            <li ng-if="item.functionalArea">{{'competency.functionalArea'|translate}}: {{ item.functionalArea }}</li>
            <li ng-if="item.competencyType">{{'competency.competencyType'|translate}}: {{ item.competencyType }}</li>
        </ul>
    </div>
</section>